var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 48 48"}},[_c('path',{attrs:{"fill":_vm.color,"d":"m31.75 28.2-2.15-2.15 3.45-2.2L16.6 13.4V9.85l22 14Zm7.9 16.35L26.6 31.5l-10 6.35V21.5L3.5 8.35l2.1-2.1 36.2 36.2ZM19.6 24.75Zm0 7.65 4.65-2.95-4.65-4.7Zm-3-19Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }